"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notifications = void 0;
// Notication Helpers
var notifications = function (issue) {
    switch (issue.message.type) {
        case 'adenc_alert1':
            return {
                message: "We've detected an anomaly that needs your attention.",
                details: "Your device may be infected. Please contact our experts for assistance.",
            };
        case 'pvm_alert1':
            return {
                message: "".concat(issue.message.program, " is out of date."),
                details: "You have version ".concat(issue.messageDetails.installed_version, " installed. Update to version ").concat(issue.messageDetails.available_version, "."),
            };
        case 'cls_url_phishing_alert1':
            return {
                message: "A suspicious website was visited.",
                details: "Website ".concat(issue.messageDetails.domain, " was accessed from the device and may be a phishing website. Change your passwords on any legitimate websites with a similar name and on any websites your were directed to from the above link."),
            };
        default:
            return {
                message: "".concat(issue.message),
                details: "".concat(issue.messageDetails),
            };
    }
};
exports.notifications = notifications;
